import React from "react";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

export default function DHIconAdd({fontSize}) {

    return <AddCircleOutlineOutlinedIcon sx={{ fontSize: fontSize }} />
}